"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../../Components/Button.js"));
var _Flex = _interopRequireDefault(require("../../Components/Flex.js"));
var _TextField = _interopRequireDefault(require("../../Components/TextField.js"));
var _withMobile = _interopRequireDefault(require("../../Hoc/withMobile.js"));
var _GiftCardLookupUiModule = _interopRequireDefault(require("./GiftCardLookupUi.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Gift Card Lookup UI
 */const GiftCardLookupUi = props => {
  const {
    disabled,
    helperText,
    inputRef,
    isMobile,
    label,
    loading,
    onChange,
    onSubmit,
    uiRef,
    value
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("form", {
    onSubmit: onSubmit,
    ref: uiRef,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
      className: _GiftCardLookupUiModule.default.formContainer,
      columnar: !isMobile,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
        color: "secondary",
        disabled: loading || disabled,
        fullWidth: true,
        helperText: helperText,
        inputRef: inputRef,
        label: label,
        maxLength: 23,
        minLength: 23,
        onChange: onChange,
        pattern: "([A-Z0-9]{5}-){3}[A-Z0-9]{5}",
        placeholder: "XXXXX-XXXXX-XXXXX-XXXXX",
        required: true,
        value: value
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        disabled: loading || disabled,
        label: "Get Details",
        loading: loading,
        type: "submit",
        variant: "contained"
      })]
    })
  });
};
GiftCardLookupUi.propTypes = {
  helperText: _propTypes.default.string,
  label: _propTypes.default.string
};
GiftCardLookupUi.defaultProps = {
  helperText: "Enter your 20-digit gift code. Dashes are not required.",
  label: "Redeem a Gift Card"
};
var _default = exports.default = (0, _withMobile.default)(GiftCardLookupUi);